<template>
  <div
    @click="isBannerClickable() ? goToLink(bannerLink) : $event.preventDefault"
    :class="[
      `mainLandingWrapper`,
      `max-view-${this.maxViewSize}`,
      `${this.screenSize}`,
      {
        'vertical-align': this.overlay == 'full',
      },
      this.bannerLink ? 'hoverLink' : null,
    ]"
    :style="cssProps"
    data-testid="sbx-pcc_landingBanner"
    v-if="propsByScreenSize"
  >
    <div
      class="overlayBackgroundWrapper"
      :class="this.overlay"
      :style="{
        backgroundColor: this.overlay === 'half' ? this.overlayBgColor : 'transparent',
      }"
      data-testid="sbx-pcc_landingBanner-overlayBackgroundWrapper"
    >
      <div class="headerSectionContainer">
        <div
          :class="[
            `headerSectionWrapper`,
            this.propsByScreenSize.MobileVerticalAlign ? `verticalAlign-${this.propsByScreenSize.MobileVerticalAlign}` : null,
          ]"
          :style="{ color: propsByScreenSize.headerColor }"
          data-testid="sbx-pcc_landingBanner-headerSectionWrapper"
        >
          <h1
            v-if="
              propsByScreenSize.headerTitle &&
              (propsByScreenSize.h1Title === undefined || propsByScreenSize.h1Title === 'true' || propsByScreenSize.h1Title === '')
            "
            :class="[`title`, `pre-formatted`, { 'mobile-align': this.screenSize == 'mobile' }]"
            :style="{ textAlign: !!propsByScreenSize.textAlign ? propsByScreenSize.textAlign : 'center' }"
            data-testid="sbx-pcc_landingBanner-title"
            v-html="parseTitle"
          />
          <p
            v-else-if="propsByScreenSize.headerTitle && propsByScreenSize.h1Title === 'false'"
            :class="[`title`, `pre-formatted`, { 'mobile-align': this.screenSize == 'mobile' }]"
            :style="{ textAlign: !!propsByScreenSize.textAlign ? propsByScreenSize.textAlign : 'center' }"
            data-testid="sbx-pcc_landingBanner-title"
            v-html="parseTitle"
          />
          <countdown-timer
            v-if="this.landingImage.timer && this.landingImage.timer.enabled === 'true' && this.overlay == 'full'"
            :year="this.landingImage.timer.year"
            :month="this.landingImage.timer.month"
            :day="this.landingImage.timer.day"
            :hour="this.landingImage.timer.hour"
            :minute="this.landingImage.timer.minute"
            :color="this.landingImage.timer.color"
            :bg-color="this.landingImage.timer.bgColor"
          />
          <p
            v-if="propsByScreenSize.headerDescription"
            class="subtitle body1 pre-formatted"
            :style="{ textAlign: !!propsByScreenSize.textAlign ? propsByScreenSize.textAlign : 'center' }"
            v-html="parseDescription"
          />
          <div :class="[`buttonContainer`, `button-size-${this.mobileBtnSize}`]" data-testid="sbx-pcc_landingBanner-buttonContainer">
            <sbx-button
              v-for="(button, index) in propsByScreenSize.buttons"
              :key="`button-${index}`"
              :data-testId="`sbx-pcc_landingBanner-button-${index}`"
              :buttonId="`sbx-button-${index}`"
              :buttonTitle="button.buttonText"
              :primaryColor="propsByScreenSize.buttonTextColour || ''"
              :secondaryColor="propsByScreenSize.buttonBgColour || ''"
              :aspectType="`button`"
              :buttonClick="() => goToLink(button.buttonLink)"
              :class="`header-button`"
              :style="{ border: `1px solid ${button.buttonBorder}` }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="landingImageWrapper" :class="this.overlay">
      <picture>
        <img
          v-bind:src="propsByScreenSize.image"
          class="landingImage"
          alt="landing page banner image"
          :data-testId="`sbx-pcc_landingBanner-landingImageWrapper-${screenSize}`"
        />
      </picture>
    </div>
  </div>
</template>

<script lang="js">
import { landingBanner } from './index.js';
import { baseUrl } from '@/SharedFe/utils/urlUtils';
import SbxButton from '@/atoms/SbxButton/SbxButton.vue';
import countdownTimer from '../CountdownTimer/CountdownTimer';

export default {
  name: 'landingBannerBase',
  components: { SbxButton, countdownTimer },
  props: {
    ...landingBanner.propTypes,
    screenSize: String,
    screenPx: Number,
  },
  data() {
    return {
      bannerSize: '',
      baseUrl,
    };
  },
  computed: {
    isFullWidthImage() {
      return this.maxViewSize === 'fullWidth';
    },
    cssProps() {
      let styles = { backgroundImage: `url('${ this.pattern }')` };
      if (this.isFullWidthImage) {
        styles = {
          backgroundImage: `url('${ this.pattern }')`,
          width: `${ this.screenPx }px`,
          maxWidth: `${ this.screenPx }px`,
        };
      }
      return styles;
    },
    propsByScreenSize() {
      if (!this.landingImage) {
        return null;
      }
      const image = (Object.keys(this.landingImage).includes(this.screenSize))
        ? this.landingImage[this.screenSize]
        : this.landingImage.base;
      const headerSection = (this.headerSection.find(ent => {
        if (ent.viewSize.length === 0) return ent;
        else
          return ent.viewSize.includes(this.screenSize);
      }));
      const buttons = (this.buttons.filter(but => {
        if (but.viewSize.length === 0) return but;
        else
          return but.viewSize.includes(this.screenSize);
      }));
      return {
        image,
        ...headerSection,
        buttons,
      };
    },
    parseTitle() {
      return this.$sanitize(this.propsByScreenSize.headerTitle);
    },
    parseDescription() {
      return this.$sanitize(this.propsByScreenSize.headerDescription);
    },
  },
  methods: {
    isBannerClickable() {
      return this.bannerLink !== '';
    },
    goToLink(buttonLink) {
      if (buttonLink.charAt(0) === '#') {
        const target = buttonLink.slice(1);
        if (document.querySelector(`[name=${ target }]`)) {
          const position = document.querySelector(`[name=${ target }]`).offsetTop;
          window.scrollTo({ top: position, behavior: 'smooth' });
        }
        return false;
      } else {
        window.location.href = baseUrl() + buttonLink;
      }
    },
  },
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
@import '@/SharedFe/scss/variables.scss';
@import '@/SharedFe/scss/typography.scss';

.pre-formatted {
  white-space: pre-wrap;
}

.vertical-align {
  justify-content: center;
  align-items: center;
}

.hoverLink {
  cursor: pointer;
}

.mainLandingWrapper {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin: 0 auto;
  // height of banner, image resizes normally . overflow hidden needed to not change ratio on img
  &:not(.mobile) {
    max-height: 480px;
    overflow: hidden;
  }

  &.mobile {
    flex-direction: column-reverse;

    & .half {
      .header-button {
        max-width: unset;
      }
    }

    & .overlayBackgroundWrapper {
      & .button-size-L {
        flex-direction: column;
        flex-grow: 1;

        & .header-button {
          min-width: unset;
          width: auto;
        }
      }

      & .button-size-M {
        flex-direction: column;
        flex-grow: 1;
        margin-left: 15%;
        margin-right: 15%;

        & .header-button {
          min-width: auto;
          width: auto;
        }
      }

      & .button-size-S {
        flex-direction: row;

        & .header-button {
          min-width: 25%;
        }
      }
    }

    & .landingImageWrapper {
      & .landingImage {
        display: block;
        min-height: 0;
        height: auto;
      }
    }

    & .overlayBackgroundWrapper.full {
      height: 100%;
      align-items: unset;

      & .headerSectionContainer {
        padding-top: 37px;
        padding-bottom: 40px;

        & .verticalAlign-top {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          height: 100%;
        }

        & .verticalAlign-bottom {
          margin-top: auto;
        }

        & .buttonContainer {
          margin-top: auto;
          flex-grow: 0;
        }
      }
    }

    & .overlayBackgroundWrapper.half {
      position: relative;
      width: 100%;

      & .headerSectionContainer {
        max-width: none;
        padding: 24px 16px 39px;
        top: 0;
        transform: none;
      }

      & .headerSectionWrapper {
        width: 100%;
      }
    }
  }

  .full {
    width: 100%;
  }

  .landingImageWrapper {
    .landingImage {
      width: 100%;
      height: min-content;
    }
  }

  .overlayBackgroundWrapper.full {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    position: absolute;

    & .headerSectionContainer {
      width: 100%;
    }

    & .headerSectionWrapper {
      width: 85%;
      @media only screen and (max-width: $mobile) {
        width: 100%;
      }
    }

    & .header-button {
      @media only screen and (max-width: 890px) {
        min-width: 40%;
        max-width: none;
      }
    }
  }

  .overlayBackgroundWrapper.half {
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 50%;

    & .headerSectionContainer {
      max-width: 550px;
      padding: 50px;
      margin: auto 0 auto auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);

      & .buttonContainer {
        & .header-button {
          @media only screen and (max-width: 890px) {
            box-sizing: border-box;
          }
        }
      }

      @media only screen and (max-width: 890px) {
        padding: rem-calc(15);
      }
    }

    & .header-button {
      min-width: 25%;
      @media only screen and (max-width: 890px) {
        min-width: 100%;
      }
    }
  }

  .headerSectionContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media only screen and (max-width: $mobile) {
      padding: 16px;
    }

    & .title {
      margin: 0 0 14px 0;
      text-align: left;
      letter-spacing: rem-calc(0.41);
      max-height: rem-calc(104);
      color: inherit;
      font-size: rem-calc(34);
      line-height: rem-calc(41);
      font-family: $brand-font-bold;
      letter-spacing: rem-calc(0.4);
      font-weight: 400;
      @media #{$mobile-up} {
        font-size: rem-calc(42);
        line-height: rem-calc(56);
      }

      &.mobile-align {
        text-align: center;
      }

      @media only screen and (max-width: $mobile) {
        margin-bottom: 8px;
      }
    }

    & .subtitle {
      margin: 0 0 14px 0;
      text-align: left;
      color: inherit;

      &.mobile-align {
        text-align: center;
      }
    }

    & .buttonContainer {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: rem-calc(30);
      justify-content: center;
      margin-top: rem-calc(20);
      @media only screen and (max-width: $mobile) {
        margin-top: rem-calc(21);
        gap: rem-calc(16);
      }

      & .header-button {
        display: flex;
        max-width: fit-content;
        font-family: $brand-font-medium;
        font-size: rem-calc(15);
        text-align: center;
        padding: rem-calc(11) rem-calc(14);
        border: 0;
        border-radius: rem-calc(5);
        text-decoration: none;
        line-height: rem-calc(20);
        flex: 1;
        flex-grow: 1;
        flex-direction: column;
        justify-content: space-around;
        word-break: break-word;
        height: auto;
        margin: initial;
        box-sizing: initial;
        align-items: center;
        @media only screen and (max-width: $mobile) {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
